import { DaoModel } from '@dynameat/models';
import { Interval } from './interval';

export class PriceChangeRestriction extends DaoModel {
  constructor(guid, name, pointOfSale, intervals) {
    super(guid);
    this.name = name || '';
    this.pointOfSale = pointOfSale || null;
    this.intervals = intervals || [];
  }

  static toInstance(props = {}) {
    const intervals = Interval.toInstanceList(props.intervals);
    return new PriceChangeRestriction(props.guid, props.name, props.point_of_sale, intervals);
  }

  isBetweenTime(dateObject) {
    // Get lowercase day string in english, for example 'monday', 'friday'
    const dayName = dateObject.toLocaleDateString('en-EN', { weekday: 'long' }).toLowerCase();
    return this.intervals.some((interval) => {
      // Check if current day is set to true  in interval, then check time is between interval times
      if (interval[dayName]) {
        return interval.isBetweenTime(dateObject);
      }
      return false;
    });
  }
}
